import { parse, stringify } from 'query-string';
import { deepmerge } from 'utilities/merge';

// export default class Base {
//   parse(query){ return parse(query);}
//   stringify(params){ return stringify(params);}
// }
export class AddressUtil {
  static parse(){
    return {};
  }
  static stringify(params){
    return stringify(params);
  }
  static mergeAndStringify(params){
    params = deepmerge(this.parse(), params);
    return this.stringify(params);
  }
}
export class AddressSearchUtil extends AddressUtil{
  static parse(){
    return parse(window.location.search);
  }
}
export class AddressHashUtil extends AddressUtil {
  static parse(){
    return parse(window.location.hash);
  }
}
